import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import toast from "react-hot-toast";
import { useMainContext } from "../../../../../../context/useMainContext";
import exportInfluencerData from "./exportUtils";

export default ({ anchorExportEl, setAnchorExportEl, setIsDotsMenuOpen }) => {
  const {
    rowsCount,
    rows,
    selected,
    filters,
    allDataForExport,
    fetchDataForExport,
    visibleColumns,
    currentColumnPreset,
  } = useMainContext();
  const open = Boolean(anchorExportEl);
  const handleClose = () => {
    setAnchorExportEl(null);
    setIsDotsMenuOpen(null);
  };

  const handleExport = async (exportType, format = "csv") => {
    try {
      const hasSelectedRows = selected && selected.length > 0;
      let dataToExport = rows;
      if (!hasSelectedRows) {
        if (allDataForExport.length === 0) {
          toast.loading(
            "Loading all data for export... This may take a while for large datasets.",
            {
              id: "export-loading",
              duration: 0,
            }
          );
          dataToExport = await fetchDataForExport();
          toast.dismiss("export-loading");
          if (!dataToExport || !Array.isArray(dataToExport)) {
            toast.error("Failed to load data for export");
            return;
          }
        } else {
          dataToExport = allDataForExport;
        }
      }
      const selectedRowData = hasSelectedRows ? selected : [];

      if (!Array.isArray(dataToExport)) {
        console.error("dataToExport is not an array:", dataToExport);
        toast.error("Invalid data format for export");
        return;
      }

      const result = await exportInfluencerData({
        allRows: dataToExport,
        filteredRows: dataToExport,
        selectedRows: selectedRowData,
        visibleColumns,
        currentColumnPreset,
        exportType,
        format,
        filters,
      });

      toast.success(result.message);
    } catch (error) {
      console.error("Export failed:", error);
      toast.error(`Export failed: ${error.message}`);
    }
  };

  return (
    <Menu
      anchorEl={anchorExportEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "280px",
            width: "auto",
          },
        },
      }}
    >
      <MenuItem
        onClick={() => {
          handleExport("filtered", "csv");
          handleClose();
        }}
        sx={{
          whiteSpace: "normal",
        }}
      >
        <ListItemIcon>
          <FilterListIcon />
        </ListItemIcon>
        <Box>
          <ListItemText primary="Filtered Export (CSV)" />
          <Typography variant="caption" color="text.secondary">
            {`${selected.length || rowsCount} of ${rowsCount} rows • Current view with filters`}
          </Typography>
        </Box>
      </MenuItem>

      <MenuItem
        onClick={() => {
          handleExport("quick", "csv");
          handleClose();
        }}
        sx={{
          whiteSpace: "normal",
        }}
      >
        <ListItemIcon>
          <DescriptionOutlinedIcon />
        </ListItemIcon>
        <Box>
          <ListItemText primary="Outreach Export (CSV)" />
          <Typography variant="caption" color="text.secondary">
            {`${selected.length || rowsCount} of ${rowsCount} rows • Username, E-mail, First Name, Contact Person`}
          </Typography>
        </Box>
      </MenuItem>
    </Menu>
  );
};
